"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'remote-followed-items/';
exports.default = {
  FOLLOW_INIT: _DOMAIN + 'FOLLOW_INIT',
  FOLLOW_SUCCESS: _DOMAIN + 'FOLLOW_SUCCESS',
  FOLLOW_FAILURE: _DOMAIN + 'FOLLOW_FAILURE',
  UNFOLLOW_INIT: _DOMAIN + 'UNFOLLOW_INIT',
  UNFOLLOW_SUCCESS: _DOMAIN + 'UNFOLLOW_SUCCESS',
  UNFOLLOW_FAILURE: _DOMAIN + 'UNFOLLOW_FAILURE',
  UNFOLLOW_BY_ID_INIT: _DOMAIN + 'UNFOLLOW_BY_ID_INIT',
  UNFOLLOW_BY_ID_SUCCESS: _DOMAIN + 'UNFOLLOW_BY_ID_SUCCESS',
  UNFOLLOW_BY_ID_FAILURE: _DOMAIN + 'UNFOLLOW_BY_ID_FAILURE',
  FETCH_INIT: _DOMAIN + 'FETCH_INIT',
  FETCH_SUCCESS: _DOMAIN + 'FETCH_SUCCESS',
  FETCH_FAILURE: _DOMAIN + 'FETCH_FAILURE',
  RELOAD_INIT: _DOMAIN + 'RELOAD_INIT',
  RELOAD_SUCCESS: _DOMAIN + 'RELOAD_SUCCESS',
  RELOAD_FAILURE: _DOMAIN + 'RELOAD_FAILURE',
  ON_FOLLOWED: _DOMAIN + 'ON_FOLLOWED',
  ON_UNFOLLOWED: _DOMAIN + 'ON_UNFOLLOWED'
};